export default __webpack_public_path__ + "static/media/segre14.ca470e05.jpg";